import React, { useEffect } from "react";
import useOrientationLock from "../../hooks/useOrientationLock";
import RotateDeviceOverlay from "../../components/RotateDeviceOverlay";
import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";
import { HeaderProgress } from "./Header";
import { ProgressGroup } from "./ProgressGroup";
import { ProgressTitle } from "./ProgressTitle";
import { ProgressTable } from "./ProgressTable";
import { useMoodle } from "../../contexts/MoodleContext";
import { ProgressChartItem } from "./ProgressChart";
import { ProgressRowItem } from "./ProgressRowItem";
import { useAuth } from "../../contexts/AuthContext";
// import { requestAutoLogin } from "../../services/moodle/userauth";
import { baseURL } from "../../services/apirest";
import { useTheme } from "../../contexts/ThemeContext";
import { readableColor } from "polished";
import { useConfig } from "../../contexts/config";
// cambio
const Progress = (/* {data} */) => {
  const { showOverlay } = useOrientationLock("portrait");
  const [grades, setGrades] = React.useState(null);
  const [tableTitles, setTableTitles] = React.useState(null);
  const moodle = useMoodle();
  const theme = useTheme();
  const { lang, user } = useAuth();
  const { config } = useConfig()
  const [sessionKey, setSessionKey] = React.useState(null);
  const [contrastColor, setContrastColor] = React.useState("#fff");

  useEffect(() => {
    lang && console.log(lang["History"]);
    if (lang && !tableTitles) {
      setTableTitles([
        lang["History"].first_column,
        lang["History"].second_column,
        lang["History"].third_column,
        lang["History"].fourth_column,
        /* lang["History"].fifth_column, */
        ...(config.opciones.includes("encuesta") ? [lang["History"].sixth_column] : [])
      ]);
    }
    // if (!sessionKey) {
    //   requestAutoLogin({ username: user.username }).then((res) => {
    //     setSessionKey(res.key);
    //   });
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  useEffect(() => {
    !moodle.courses && moodle.getCourses();
    fetchGrades();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (theme && theme.styles?.bg_course_group) {
      if (
        theme.styles?.bg_course_group?.backgroundColor === "rgba(0, 0, 0, 0.05)"
      ) {
        setContrastColor("#1A1A1ACC");
      } else {
        setContrastColor(
          readableColor(theme.styles?.bg_course_group?.backgroundColor)
        );
      }
    }
  }, [theme]);

  async function fetchGrades() {
    const res = await moodle.getProgress();
        console.log({ res });
    setGrades(res.grades);
  }

  return (
    <>
      <RotateDeviceOverlay show={showOverlay} />
      {lang && (
        <>
          <Navbar />
          {/* {sessionKey && (
            <iframe
              src={`${baseURL}auth/userkey/login.php?key=${sessionKey}&wantsurl=${baseURL}`}
              id="login-token"
              frameBorder="0"
              width="0"
              allow="autoplay ; microphone; camera"
              height={"0"}
              title="login-token"
            />
          )} */}

          <div
            className="flex flex-col items-center w-full px-4 py-48 min-h-dvh"
            style={{
              backgroundColor: theme.colors.backgroundColorBody
                ? theme.colors.backgroundColorBody
                : theme.mode === "light"
                ? "rgba(0, 0, 0, 0.05)"
                : "rgb(34, 34, 34)", // TODO: Cambiar Styles por Colors
              gap: "36px",
            }}
          >
            <div className="container w-full space-y-3">
              {/* <ProgressTitle title={lang["History"].first_title} /> */}
              <p
                className="font-medium text-4xl"
                style={{
                  color: readableColor(
                    theme.colors.backgroundColorBody
                      ? theme.colors.backgroundColorBody
                      : theme.mode === "light"
                      ? "rgba(0, 0, 0, 0.05)"
                      : "rgb(34, 34, 34)"
                  ),
                }}
              >
                {lang["History"].first_title}
              </p>
              <ProgressTable headers={tableTitles}>
                {moodle.courses &&
                  grades &&
                  moodle.courses.map((c, idx) => {
                      let grade = grades.filter((g) => g.courseid === c.id)[0]
                        ?.grade
                        ? grades.filter((g) => g.courseid === c.id)[0].grade
                        : "-";
                      grade = grade.split("(")[0]; // quitar el porcentaje
                      console.log(c);
                      console.log(grades);
                      return (
                        <ProgressRowItem
                          key={idx}
                          course={c}
                          grade={grade}
                          lang={lang}
                          includeEncuesta={config.opciones.includes("encuesta")}
                        />
                      );
                  })}
              </ProgressTable>
            </div>

            <div className="container w-full">
              {/* <HeaderProgress lang={lang} /> */}
              <p
                className="font-medium text-4xl"
                style={{
                  color: readableColor(
                    theme.colors.backgroundColorBody
                      ? theme.colors.backgroundColorBody
                      : theme.mode === "light"
                      ? "rgba(0, 0, 0, 0.05)"
                      : "rgb(34, 34, 34)"
                  ),
                }}
              >
                {lang["History"].second_title}
              </p>
              <ul className="progress-list mt-4">
                <li
                  className="progress-list"
                  style={{ color: theme.mode === "light" ? "#16232c" : "#fff" }}
                >
                  {" "}
                  {/* 
      
                </li>
                <li className="progress-list" style={{color: theme.mode === "light" ? "#16232c" : "#fff"}}> {/* //TODO: Cambiar Styles por Colors */}
                  <div
                    className="p-[5px] border-[1px] border-solid border-[#232323] rounded-md mr-2"
                    style={{
                      backgroundColor:
                        theme.mode === "dark"
                          ? theme.colors.backgroundPendienteLight
                          : theme.colors.backgroundPendienteDark, // TODO: Cambiar Palette por Colors
                      borderColor: contrastColor,
                    }}
                  />
                  &nbsp;{lang["History"].complete}
                  <div
                    className="p-[5px] border-[1px] border-solid border-[#232323] rounded-md ml-5"
                    style={{
                      backgroundColor:
                        theme.mode === "light"
                          ? "rgba(0, 0, 0, 0.05)"
                          : "rgb(34, 34, 34)", // TODO: Cambiar Palette por Colors
                      borderColor: contrastColor,
                    }}
                  />
                  &nbsp;{lang["History"].pending}
                </li>
              </ul>
            </div>
            <div className="container w-full">
              <ProgressGroup>
                {moodle.courses &&
                  moodle.courses.map((c, idx) => {
                      return (
                        <ProgressChartItem
                          key={idx}
                          course={c}
                          lang={lang}
                          
                        />
                      );
                  })}
              </ProgressGroup>
            </div>
          </div>
        </>
      )}
    </>
  );
};

// return (
//   <>
//     {lang && (
//       <>
//         <Navbar />
//         {sessionKey && (
//           <iframe
//             src={`${baseURL}auth/userkey/login.php?key=${sessionKey}&wantsurl=${baseURL}`}
//             id="login-token"
//             frameBorder="0"
//             width="0"
//             allow="autoplay ; microphone; camera"
//             height={"0"}
//             title="login-token"
//           />
//         )}
//         <div style={styles.progressBlock}>
//           <div style={styles.wrapper}>
//             <ProgressTitle title={lang["History"].first_title} />
//             <ProgressTable headers={tableTitles}>
//               {moodle.courses &&
//                 grades &&
//                 moodle.courses.map((c, idx) => {
//                   let grade = grades.filter((g) => g.courseid === c.id)[0]
//                     ?.grade
//                     ? grades.filter((g) => g.courseid === c.id)[0].grade
//                     : "-";
//                   console.log(c)
//                   return (
//                     <ProgressRowItem
//                       key={idx}
//                       course={c}
//                       grade={grade}
//                       lang={lang}
//                     />
//                   );
//                 })}
//             </ProgressTable>
//           </div>
//           <HeaderProgress lang={lang} />
//           <div className="container w-full">
//             <ProgressGroup>
//               {moodle.courses &&
//                 moodle.courses.map((c, idx) => {
//                   return <ProgressChartItem key={idx} course={c} lang={lang} />;
//                 })}
//             </ProgressGroup>
//           </div>
//         </div>
//         <Footer />
//       </>
//     )}
//   </>
// );
// const styles = {
//   wrapper: {
//     paddingTop: "12rem",
//   },
//   progressBlock: {
//     justifyContent: "center",
//     width: "80%",
//     marginLeft: "10%",
//     paddingBottom: "0",
//   },
// };

export default Progress;
